export default "__VITE_ASSET__BOC1C4nO__"